import { Bando } from "./bando.model";
import { Impresa } from "./impresa.model";

export class Oda {
  id?: number;
  numero?: number;
  azienda?: Impresa;
  bando?: Bando;
  lotti?: string;
  referenteTim?: string;
  importo?: number;
  importoImpegnato?: number;
  importoEmEmesse?: number;
  importoPagato?: number;
  importoResiduo?: number;
  percentualeResidua?: number;
  creato?: Date; 
  modificato?: Date; 
  completato?: Date; 
  dataUltimoMdp?:Date;
}